import _extends from 'babel-runtime/helpers/extends';

import UploaderBar from '@com/components/asset-uploader/uploader-bar.vue';
import { mapState } from 'vuex';

export default {
  components: {
    UploaderBar: UploaderBar
  },

  props: {
    resourceTotal: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {};
  },


  computed: _extends({}, mapState({
    resourceUploader: function resourceUploader(state) {
      return state.creative.asset.resourceUploader;
    },
    freeSize: function freeSize(state) {
      return state.assets.uploader.freeSize;
    }
  }), {
    isStorageFull: function isStorageFull() {
      return this.freeSize < 0 && this.freeSize !== -1;
    }
  }),

  methods: {
    uploadComplete: function uploadComplete() {
      this.$emit('uploadComplete');
    },
    handleClick: function handleClick() {
      this.$emit('dialogTrigger');
    }
  }
};